import env from '../../env';
import honghuConfig from './honghu';
import defaultConfig from './default';
var envPlatform = {
    honghu: env.isHonghu
    // hk: env.isHk
};
var configMap = {
    honghu: honghuConfig,
    // hk: hkConfig,
    default: defaultConfig
};
var platform = '';
for (var env_1 in envPlatform) {
    if (!platform && envPlatform[env_1]) {
        platform = env_1;
    }
}
export default configMap[platform || 'default'] || defaultConfig;
